/* global videoID */

// import
import 'babel-polyfill';
import $ from 'jquery';
import debounce from 'cmnjs/function/debounce';
import throttle from 'cmnjs/function/throttle';
import config from './app/config';
import overlay from './app/overlay';
import opacityLayer from './app/opacityLayer';
import floatingTitle from './app/floatingTitle';
import CCform from './app/ccforms';
import svgIcons from './app/svgIcons';
import waypoints from './app/waypoints';
import search from './app/search';
import video from './app/video';
import responsiveTables from './vendor/responsive-table';
import imageSwitch from './app/imageSwitcher';
import topNavigation from './app/topNavigation';
import languageSwitcher from './app/languageSwitcher';

import '../../../common/js/vendor/noframework.waypoints';
import './plugins/filterItems';
import './plugins/slider';
import './vendor/animatescroll';
import './vendor/jquery.smartbanner';
import './plugins/stepper';
import './vendor/rodo';
import './vendor/rodo.v4';

// vars
let $body;
let $window;
let $faqPage;
let $helpPage;
let $navTop;
let $functionList;
let $mainPageSlider;
let $videoPage;
let $pageOverlay;
let $forms;
let $animateScrollBtns;
let $searchForm;
let isHomepage = false;
let $stepper;
let $responsiveImages;

// tylko dla WID-ów -> TODO - fiks mi
global.jQuery = $;
global.$ = $;
// require globalów i pluginów jQuery

// wszystko co resize to tu
function resizehandler() {
  config.desktop = window.matchMedia('(min-width: 850px)').matches;
  config.showImages = window.matchMedia('(min-width: 500px)').matches;

  overlay.resize($pageOverlay);
  floatingTitle.resize();
  opacityLayer.resize();
  search.resize();
  topNavigation.resize();

  if (config.desktop) {
    $('.layout-safety-rules').css({
      minHeight: $('.layout-safety-rules__left').height(),
    });
  }

  $('.menu').width($(window).width());
  responsiveTables.resize();

  imageSwitch.resize($responsiveImages);

  if (config.desktop && isHomepage) {
    waypoints.switchMouseWheel($('.waypoints').is(':visible'));
  }
}

function scrollHandler(event) {
  $navTop[`${this.scrollTop() > 10 ? 'add' : 'remove'}Class`]('show-navigation-bg');

  opacityLayer.scroll();

  floatingTitle.scroll();

  if (config.desktop && isHomepage && !document.body.classList.contains('__pko-cookie-mobile-blocked__')) {
    waypoints.scroll();
  }
}

function loadEvents() {
  const $menu = $('.menu__hamburger');
  const $closeMenu = $('.navigation__close, .side-navigation__close');
  const hideOverlay = overlay.hideOverlay.bind(null, $pageOverlay);
  const showOverlay = overlay.showOverlay.bind(null, $pageOverlay);
  const $cookie = $('.cookie');
  const $waypoint = $('.waypoints').first();

  $menu.click(() => {
    $body.addClass('nav-active');
    if ($cookie.length) {
      $cookie.hide();
    }
    showOverlay();
    $menu.css('visibility', 'hidden');
  });

  $closeMenu.click(() => {
    $body.removeClass('nav-active');
    if ($cookie.length) {
      $cookie.show();
    }
    hideOverlay();
    $menu.css('visibility', 'visible');
  });

  $animateScrollBtns.click(function (e) {
    const $target = $(this.href.substring(this.href.indexOf('#')));

    if ($target.length) {
      e.preventDefault();

      $target.animatescroll({
        scrollSpeed: 1000,
        easing: 'easeOutCubic',
      });
    }
  });

  // tu podpinamy wszystkie scrolle
  $window.on('scroll touchmove', throttle(scrollHandler.bind($window), 100));

  if (config.desktop && isHomepage && $waypoint.is(':visible')) {
    waypoints.switchMouseWheel(true);
  }

  // tu wszystkie resize eventy w resizehandler, najpierw sprawdzenie czy desktop, potem coś zależne od tego
  $window.on('resize', debounce(resizehandler, 200));

  // to trzeba gdzieś przenieść i zcache'ować
  $('.navigation__search-input').on('focus', function () {
    $('.navigation__content').animate({
      scrollTop: $(this).offset().top,
    });
  });
}

function loadFaqFilter() {
  // troche mało żeby to wciskać w plugin...
  $('.faq__list-item').on('click', function () {
    // todo - przenieść do modułu?
    // todo - podpiąć opacityLayer.scroll...?
    const $this = $(this);
    const answer = $this.find('.faq__answer');

    $this.toggleClass('expanded');

    const isExpanded = $this.hasClass('expanded');

    answer[`slide${isExpanded ? 'Down' : 'Up'}`]();
    $this.find('span span').text(isExpanded ? '-' : '+');

    $('.faq__answer').click(e => {
      e.stopPropagation();
    });
  });

  $('.filter__buttons').filterItems({
    listItems: $('.faq__list-item'),
    reduceItems: true,
  });
}

function loadHelpFilter() {
  $('.filter__buttons').filterItems({
    listItems: $('.listing__item'),
    reduceItems: false,
    showAllButton: $('.js-show-all-button'),
  });
}

function loadFunctionListFilter() {
  $('.filter__buttons').filterItems({
    listItems: $('.listing__item'),
    reduceItems: false,
  });
}

function loadMainPageSlider() {
  $mainPageSlider.each(function () {
    const $this = $(this);

    $this.slider({
      speed: 500,
      dots: $this.parents('.standard-wrap__middle').find('.slider__dots'),
      arrows: $this.parents('.standard-wrap__middle').find('.slider__arrows'),
      hiddenSlide: false,
    });
  });
}

function formatStoreButton(link, forceGoogle) {
  if (!link.length) {
    return;
  }

  const userAgentString = navigator.userAgent;

  if (/Android/.test(userAgentString) || forceGoogle) {
    link.attr('href', link.attr('data-android'));
  } else if (/ip(hone|od|ad)/i.test(userAgentString)) {
    link.attr('href', link.attr('data-apple'));
  } else if (/Windows Phone/.test(userAgentString)) {
    link.attr('href', link.attr('data-windows'));
  }
}

function init() {
  // kluczowe, bo chcemy dom ready
  config.init();
  floatingTitle.init();
  opacityLayer.init();
  responsiveTables.init();
  topNavigation.init();
  languageSwitcher.init();

  if ($('.home').length) {
    isHomepage = true;
    // waypoints.init();
  }

  // fallback dla symboli svg
  svgIcons();

  // vars
  // tu wybieramy główne jQuery elementy
  $body = config.$el.body;
  $window = config.$el.window;
  $faqPage = $('.layout-faq');
  $helpPage = $('.help');
  $navTop = $('.menu');
  $functionList = $('.function');
  $mainPageSlider = $('.slider');
  $videoPage = $('.function__video');
  $pageOverlay = $('.page-overlay');
  $forms = $('.ccform');
  $animateScrollBtns = $('.animatescroll');
  $searchForm = $('.search-top__form');
  $stepper = $('.no-touch .stepper');
  $responsiveImages = $('.js-responsive-image');

  // init
  // 'desktop' var
  resizehandler();


  // init
  scrollHandler.call($window, null);

  loadEvents();

  if ($mainPageSlider.length) {
    loadMainPageSlider();
  }

  if ($faqPage.length) {
    loadFaqFilter();
  }

  if ($functionList.length) {
    loadFunctionListFilter();
  }

  if ($helpPage.length) {
    loadHelpFilter();
  }

  if ($videoPage.length && videoID) {
    video.init('#vid1');
  }

  if ($forms.length) {
    $forms.each(function () {
      $(this).data('ccform', new CCform(this).init());
    });
  }

  if ($stepper.length) {
    $stepper.stepper();
  }

  if ($searchForm.length) {
    search.init();
  }

  if ($responsiveImages.length) {
    imageSwitch.init();
  }

  if (!config.desktop) {
    formatStoreButton($('#pobierz-aplikacje-button'));
    formatStoreButton($('#pobierz-aplikacje-button-top'));
  }

  $.smartbanner({
    title: 'IKO',
    author: 'PKO Bank Polski',
    price: 'FREE',
    appStoreLanguage: 'pl',
    inAppStore: 'w App Store',
    inGooglePlay: 'w Google Play',
    inAmazonAppStore: 'w Amazon Appstore',
    inWindowsStore: 'w Windows Store',
    GooglePlayParams: null, // Aditional parameters for the market
    icon: 'https://www.pkobp.pl/static/dist-tracked/front/iko-app-lite/img/iko-icon.png', // The URL of the icon (defaults to <meta name="apple-touch-icon">)
    iconGloss: null, // Force gloss effect for iOS even for precomposed
    url: null, // The URL for the button. Keep null if you want the button to link to the app store.
    button: 'Pokaż', // Text for the install button
    scale: 'auto', // Scale based on viewport size (set to 1 to disable)
    speedIn: 300, // Show animation speed of the banner
    speedOut: 400, // Close animation speed of the banner
    daysHidden: 15, // Duration to hide the banner after being closed (0 = always show banner)
    daysReminder: 90, // Duration to hide the banner after "VIEW" is clicked *separate from when the close button is clicked* (0 = always show banner)
    force: null, // Choose 'ios', 'android' or 'windows'. Don't do a browser check, just always show this banner
    hideOnInstall: true, // Hide the banner after "VIEW" is clicked.
    layer: false, // Display as overlay layer or slide down the page
    iOSUniversalApp: true, // If the iOS App is a universal app for both iPad and iPhone, display Smart Banner to iPad users, too.
    appendToSelector: 'body', // Append the banner to a specific selector
    onInstall() {
      //
    },
    onClose() {
      //
    },
  });
}

// jeden punkt startu dla całości projektu
$(init);



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/main.js